import type {Result} from './Result';

export const Err = <E>(error?: E): Result<never, E> => {
  return {ok: false, error};
};
